import { render, staticRenderFns } from "./SuppliersRemover.vue?vue&type=template&id=eea82778&scoped=true&"
import script from "./SuppliersRemover.vue?vue&type=script&lang=js&"
export * from "./SuppliersRemover.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersRemover.vue?vue&type=style&index=0&id=eea82778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea82778",
  null
  
)

export default component.exports